// 💬 HLP — la barra de ayuda contextual, abajo a la izquierda. Clon del
// 💬HLP.js de 0101sanity/nexus con el diccionario de drop-killer.
//
// Al posar el ratón (o el foco) sobre cualquier [data-action] o [data-tip],
// la barra dice qué hace eso. El texto sale de `data-tip` del propio elemento
// si lo lleva (el rail, la toolbar, la miga, los botones de ajustes); si no,
// del diccionario HELP de aquí, por acción. Sin ninguno de los dos, no enseña
// nada.
//
// La clave (arriba, en mono) es `data-key` o, si no, `data-action`: la misma
// palabra que se ve en el código, así que sirve de vocabulario común.
//
// ⚠️ LAS FRASES DICEN LO QUE EL CÓDIGO HACE, no lo que parece: se leen en su
// handler antes de escribirlas (📂BRW, 📊GRD, 🔍SRC, ⚙️SET).
//
// Vive en el shell (👨NAV.js lo pinta: `.HLP#help`) y se ata UNA vez en el
// boot: escucha en document, así que vale para lo que las vistas pinten
// después.

import './💬HLP.pcss'

const HELP = {
  'theme-toggle': 'Cambia entre tema claro y oscuro. Se recuerda en este navegador.',
  'upload':       'Elige archivos de tu equipo y súbelos a la carpeta en la que estás. También puedes soltarlos en cualquier sitio del panel.',
  'mkdir':        'Crea una carpeta dentro de la que estás viendo.',
  'sort':         'Ordena por nombre, tamaño o fecha. Pulsa otra vez para invertir el orden. Las carpetas van siempre primero.',
  'mode':         'Cuadrícula (con portada para fotos y vídeos) o lista densa.',
  'rename':       'Cambia el nombre de este dispositivo. Sólo es una etiqueta para que lo reconozcas.',
  'revoke':       'Revoca este passkey: ese dispositivo deja de poder abrir el panel. El último no se puede revocar.',
  'add':          'Registra un passkey nuevo. El navegador te deja usar este equipo, una llave de seguridad o un móvil por QR.',
}

const LEAVE_MS = 220
const SWAP_MS = 140

let hlpEl = null
let keyEl = null
let txtEl = null
let leaveTimer = null
let swapTimer = null
let current = null          // el elemento que se está explicando

export function initHelp() {
  hlpEl = document.getElementById('help')
  keyEl = document.getElementById('help-key')
  txtEl = document.getElementById('help-txt')
  if (!hlpEl || !keyEl || !txtEl) {
    console.error('[drop-killer] HLP: faltan #help/#help-key/#help-txt — los pinta 👨NAV.js')
    return
  }

  // En pantallas sin hover (táctil) el mouseover que sintetiza un toque dejaría
  // la barra clavada hasta el toque siguiente: ahí sólo responde al foco.
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', onEnter)
    document.addEventListener('mouseout', onLeave)
  }
  document.addEventListener('focusin', onEnter)
  document.addEventListener('focusout', onLeave)
  document.addEventListener('keydown', e => { if (e.key === 'Escape') hide() })
}

function textFor(el) {
  if (el.dataset.tip) return el.dataset.tip
  const action = el.dataset.action || el.dataset.act
  return action ? HELP[action] : undefined
}

function keyFor(el) {
  return el.dataset.key || el.dataset.action || el.dataset.act || ''
}

function onEnter(e) {
  const el = e.target.closest?.('[data-action], [data-act], [data-tip]')
  if (!el) return
  const text = textFor(el)
  if (!text) return
  clearTimeout(leaveTimer)
  show(el, text)
}

function onLeave(e) {
  const el = e.target.closest?.('[data-action], [data-act], [data-tip]')
  if (!el) return
  clearTimeout(leaveTimer)
  leaveTimer = setTimeout(hide, LEAVE_MS)
}

function write(el, text) {
  keyEl.textContent = keyFor(el)
  txtEl.textContent = text
  current = el
}

function show(el, text) {
  if (el === current && hlpEl.classList.contains('HLP--on')) return
  clearTimeout(swapTimer)

  // Primera aparición: sin cruce, sólo entra
  if (!hlpEl.classList.contains('HLP--on')) {
    write(el, text)
    hlpEl.classList.add('HLP--on')
    return
  }

  // Ya visible: cruce del contenido y la altura acompaña
  const prevH = hlpEl.offsetHeight
  hlpEl.classList.add('HLP--swap')
  swapTimer = setTimeout(() => {
    write(el, text)
    const nextH = hlpEl.offsetHeight
    if (prevH !== nextH && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      hlpEl.animate(
        [{ height: `${prevH}px` }, { height: `${nextH}px` }],
        { duration: 260, easing: 'cubic-bezier(.771,.029,.189,1.007)', fill: 'none' },
      )
    }
    hlpEl.classList.remove('HLP--swap')
  }, SWAP_MS)
}

export function hideHelp() { hide() }

function hide() {
  clearTimeout(swapTimer)
  hlpEl?.classList.remove('HLP--on', 'HLP--swap')
  current = null
}
